// Adventure decision trees and choices for all tours

export const adventureTemplates = [
  {
    id: 'everest-base-camp',
    name: 'Everest Base Camp Trek',
    shortName: 'EBC Trek',
    description: 'Stand at the foot of the world\'s highest peak',
    region: 'Nepal - Everest',
    basePrice: 3000,
    baseDuration: 12,
    baseDifficulty: 'moderate',
    heroImage: 'https://images.pexels.com/photos/163404/mount-everest-himalayas-lhotse-chomolungma-163404.jpeg',
    mapRoute: 'M100,300 L150,250 L200,200 L250,150 L300,100',
    baseItinerary: [
      { day: 1, title: 'Arrival in Kathmandu', location: { x: 100, y: 300 } },
      { day: 2, title: 'Fly to Lukla & Trek to Phakding', location: { x: 150, y: 250 } },
      { day: 3, title: 'Phakding to Namche Bazaar', location: { x: 200, y: 200 } },
      { day: 4, title: 'Acclimatization in Namche', location: { x: 200, y: 200 } },
      { day: 5, title: 'Namche to Tengboche', location: { x: 250, y: 150 } },
      { day: 6, title: 'Tengboche to Dingboche', location: { x: 280, y: 120 } },
      { day: 7, title: 'Acclimatization in Dingboche', location: { x: 280, y: 120 } },
      { day: 8, title: 'Dingboche to Lobuche', location: { x: 300, y: 100 } },
      { day: 9, title: 'Lobuche to Gorak Shep & EBC', location: { x: 320, y: 80 } },
      { day: 10, title: 'Gorak Shep to Pheriche', location: { x: 280, y: 120 } },
      { day: 11, title: 'Pheriche to Namche', location: { x: 200, y: 200 } },
      { day: 12, title: 'Namche to Lukla & Fly to Kathmandu', location: { x: 100, y: 300 } }
    ],
    decisionPoints: [
      {
        id: 'ebc-journey-start',
        title: 'The Journey to Lukla',
        description: 'How would you like to begin your legendary trek?',
        timing: 'beforeDay2',
        options: [
          {
            id: 'standard-flight',
            title: 'Take the Scenic Flight to Lukla',
            description: 'Experience the thrilling mountain flight - one of the world\'s most dramatic airport landings',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Standard Route',
            selected: true
          },
          {
            id: 'jiri-trek',
            title: 'Trek from Jiri - The Pioneer\'s Route',
            description: 'Follow Sir Edmund Hillary\'s original path. A true adventure through rural Nepal before reaching Lukla',
            impact: { days: 5, cost: 450, difficulty: 1 },
            badge: 'Epic Addition',
            addedItinerary: [
              { day: 'X+1', title: 'Drive to Jiri & Trek to Bhandar' },
              { day: 'X+2', title: 'Bhandar to Sete' },
              { day: 'X+3', title: 'Sete to Junbesi' },
              { day: 'X+4', title: 'Junbesi to Nunthala' },
              { day: 'X+5', title: 'Nunthala to Lukla' }
            ]
          }
        ]
      },
      {
        id: 'ebc-acclimatization',
        title: 'Acclimatization & Exploration',
        description: 'Make the most of your acclimatization day in Namche Bazaar',
        timing: 'day4',
        options: [
          {
            id: 'standard-acclimatization',
            title: 'Standard Acclimatization Day',
            description: 'Hike to Everest View Hotel and explore the vibrant Sherpa capital',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Included',
            selected: true
          },
          {
            id: 'helicopter-tour',
            title: 'Helicopter Tour to Everest View Hotel',
            description: 'Soar above the Himalayas for breathtaking aerial views and champagne breakfast',
            impact: { days: 0, cost: 750, difficulty: 0 },
            badge: 'Luxury Experience'
          },
          {
            id: 'gokyo-lakes',
            title: 'Detour to Gokyo Lakes',
            description: 'Trek to the stunning turquoise Gokyo Lakes and climb Gokyo Ri (5,357m) for panoramic views',
            impact: { days: 3, cost: 600, difficulty: 2 },
            badge: 'Adventure Plus',
            addedItinerary: [
              { day: 'X+1', title: 'Namche to Dole via Gokyo Valley' },
              { day: 'X+2', title: 'Dole to Gokyo Lakes' },
              { day: 'X+3', title: 'Climb Gokyo Ri & Return to Main Trail' }
            ]
          }
        ]
      },
      {
        id: 'ebc-summit-challenge',
        title: 'The Summit Challenge',
        description: 'Reach Everest Base Camp and beyond',
        timing: 'day9',
        options: [
          {
            id: 'ebc-only',
            title: 'Everest Base Camp',
            description: 'Trek directly to the legendary base camp at 5,364m',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Classic',
            selected: true
          },
          {
            id: 'kala-patthar',
            title: 'Summit Kala Patthar at Sunrise',
            description: 'Pre-dawn climb to 5,545m for the ultimate Everest sunrise view',
            impact: { days: 0.5, cost: 0, difficulty: 1 },
            badge: 'Epic Viewpoint',
            addedItinerary: [
              { day: 'X', title: '3am start for Kala Patthar Summit & Sunrise' }
            ]
          }
        ]
      },
      {
        id: 'ebc-descent',
        title: 'The Descent',
        description: 'Choose your return journey',
        timing: 'day10',
        options: [
          {
            id: 'trek-back',
            title: 'Trek the Classic Route Back',
            description: 'Descend through the villages, soaking in the accomplishment',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Traditional',
            selected: true
          },
          {
            id: 'helicopter-return',
            title: 'Helicopter Flight from Gorak Shep',
            description: 'Save time with a thrilling helicopter ride back to Kathmandu with aerial mountain views',
            impact: { days: -3, cost: 1200, difficulty: -1 },
            badge: 'Luxury Exit'
          }
        ]
      }
    ]
  },
  {
    id: 'annapurna-circuit',
    name: 'Annapurna Circuit Trek',
    shortName: 'Annapurna Circuit',
    description: 'Circle the Annapurna massif through diverse landscapes',
    region: 'Nepal - Annapurna',
    basePrice: 2000,
    baseDuration: 11,
    baseDifficulty: 'moderate',
    heroImage: 'https://images.unsplash.com/photo-1720810828643-3b70f8e4cb2a',
    mapRoute: 'M50,350 L100,300 L200,250 L300,200 L350,250 L400,300',
    baseItinerary: [
      { day: 1, title: 'Arrival in Kathmandu', location: { x: 50, y: 350 } },
      { day: 2, title: 'Drive to Besisahar & Trek to Bhulbhule', location: { x: 100, y: 300 } },
      { day: 3, title: 'Trek to Chamje', location: { x: 150, y: 270 } },
      { day: 4, title: 'Trek to Bagarchhap', location: { x: 200, y: 250 } },
      { day: 5, title: 'Trek to Chame', location: { x: 250, y: 220 } },
      { day: 6, title: 'Trek to Manang', location: { x: 300, y: 200 } },
      { day: 7, title: 'Acclimatization in Manang', location: { x: 300, y: 200 } },
      { day: 8, title: 'Trek to Thorong Phedi', location: { x: 320, y: 180 } },
      { day: 9, title: 'Cross Thorong La Pass to Muktinath', location: { x: 350, y: 250 } },
      { day: 10, title: 'Trek to Jomsom', location: { x: 380, y: 280 } },
      { day: 11, title: 'Fly to Pokhara & Kathmandu', location: { x: 50, y: 350 } }
    ],
    decisionPoints: [
      {
        id: 'annapurna-start',
        title: 'Starting Point Choice',
        description: 'Where would you like to begin your circuit?',
        timing: 'beforeDay2',
        options: [
          {
            id: 'besisahar-start',
            title: 'Start from Besisahar',
            description: 'The classic starting point with gradual altitude gain',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Classic Route',
            selected: true
          },
          {
            id: 'manang-shortcut',
            title: 'Drive Directly to Manang',
            description: 'Skip the lower sections and start from the Tibetan plateau',
            impact: { days: -4, cost: 200, difficulty: -1 },
            badge: 'Time Saver'
          }
        ]
      },
      {
        id: 'annapurna-side-trek',
        title: 'Acclimatization Adventure',
        description: 'Make the most of your rest day in Manang',
        timing: 'day7',
        options: [
          {
            id: 'standard-rest',
            title: 'Standard Acclimatization',
            description: 'Explore Manang village and hike to Gangapurna Lake',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Included',
            selected: true
          },
          {
            id: 'ice-lake',
            title: 'Ice Lake Trek',
            description: 'Challenging hike to pristine Ice Lake at 4,600m',
            impact: { days: 0, cost: 100, difficulty: 1 },
            badge: 'Challenge'
          },
          {
            id: 'tilicho-lake',
            title: 'Tilicho Lake Expedition',
            description: 'Trek to one of the world\'s highest lakes (4,919m)',
            impact: { days: 2, cost: 400, difficulty: 2 },
            badge: 'Epic Detour',
            addedItinerary: [
              { day: 'X+1', title: 'Trek to Tilicho Base Camp' },
              { day: 'X+2', title: 'Tilicho Lake & Return to Manang' }
            ]
          }
        ]
      },
      {
        id: 'annapurna-descent',
        title: 'The Kali Gandaki Descent',
        description: 'After crossing Thorong La, choose your descent route',
        timing: 'day10',
        options: [
          {
            id: 'fly-jomsom',
            title: 'Fly from Jomsom',
            description: 'Quick flight through the deepest gorge on Earth',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Standard',
            selected: true
          },
          {
            id: 'trek-to-pokhara',
            title: 'Trek to Pokhara',
            description: 'Complete the full circuit by trekking down the Kali Gandaki gorge',
            impact: { days: 4, cost: -150, difficulty: 1 },
            badge: 'Completionist',
            addedItinerary: [
              { day: 'X+1', title: 'Jomsom to Tatopani' },
              { day: 'X+2', title: 'Tatopani to Ghorepani' },
              { day: 'X+3', title: 'Poon Hill Sunrise & Trek to Hile' },
              { day: 'X+4', title: 'Hile to Pokhara' }
            ]
          }
        ]
      }
    ]
  },
  {
    id: 'kailash-mansarovar',
    name: 'Kailash Mansarovar Yatra',
    shortName: 'Kailash Yatra',
    description: 'Sacred pilgrimage to Mount Kailash',
    region: 'Tibet',
    basePrice: 3400,
    baseDuration: 12,
    baseDifficulty: 'challenging',
    heroImage: 'https://images.unsplash.com/photo-1606163338600-0e212c836bb3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxNb3VudCUyMEthaWxhc2h8ZW58MHx8fHwxNzYwNjkxOTUwfDA&ixlib=rb-4.1.0&q=85',
    mapRoute: 'M100,350 L200,300 L300,200 L350,200 L350,250 L300,250 L200,300 L100,350',
    baseItinerary: [
      { day: 1, title: 'Arrival in Kathmandu', location: { x: 100, y: 350 } },
      { day: 2, title: 'Kathmandu Sightseeing', location: { x: 100, y: 350 } },
      { day: 3, title: 'Drive to Syabrubesi', location: { x: 150, y: 320 } },
      { day: 4, title: 'Cross to Kerung (Tibet)', location: { x: 200, y: 300 } },
      { day: 5, title: 'Drive to Saga', location: { x: 250, y: 250 } },
      { day: 6, title: 'Drive to Lake Mansarovar', location: { x: 300, y: 200 } },
      { day: 7, title: 'Lake Mansarovar to Darchen', location: { x: 320, y: 200 } },
      { day: 8, title: 'Darchen to Diraphuk (Kailash Parikrama Day 1)', location: { x: 350, y: 200 } },
      { day: 9, title: 'Cross Dolma La to Zuthulphuk (Parikrama Day 2)', location: { x: 350, y: 250 } },
      { day: 10, title: 'Complete Parikrama to Darchen', location: { x: 320, y: 250 } },
      { day: 11, title: 'Drive to Saga', location: { x: 250, y: 250 } },
      { day: 12, title: 'Return to Kathmandu', location: { x: 100, y: 350 } }
    ],
    decisionPoints: [
      {
        id: 'kailash-preparation',
        title: 'Spiritual Preparation',
        description: 'Enhance your pilgrimage experience',
        timing: 'day2',
        options: [
          {
            id: 'standard-prep',
            title: 'Standard Temple Visits',
            description: 'Visit Pashupatinath and prepare for the journey',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Included',
            selected: true
          },
          {
            id: 'extended-prep',
            title: 'Extended Spiritual Journey',
            description: 'Additional day visiting Muktinath and other sacred sites',
            impact: { days: 1, cost: 200, difficulty: 0 },
            badge: 'Spiritual Plus'
          }
        ]
      },
      {
        id: 'kailash-parikrama',
        title: 'The Sacred Parikrama',
        description: 'Choose your circumambulation style',
        timing: 'day8',
        options: [
          {
            id: 'standard-parikrama',
            title: 'Three-Day Parikrama',
            description: 'Traditional three-day circuit around Mount Kailash',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Traditional',
            selected: true
          },
          {
            id: 'one-day-parikrama',
            title: 'One-Day Parikrama Challenge',
            description: 'Complete the 52km circuit in a single day (for experienced trekkers)',
            impact: { days: -2, cost: 300, difficulty: 3 },
            badge: 'Ultimate Challenge'
          }
        ]
      },
      {
        id: 'kailash-extras',
        title: 'Sacred Lake Experience',
        description: 'Enhance your time at Lake Mansarovar',
        timing: 'day6',
        options: [
          {
            id: 'standard-lake',
            title: 'Standard Lake Visit',
            description: 'Holy dip and puja ceremony',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Included',
            selected: true
          },
          {
            id: 'extended-lake',
            title: 'Extended Lake Stay',
            description: 'Additional night camping by the sacred lake with meditation sessions',
            impact: { days: 1, cost: 350, difficulty: 0 },
            badge: 'Spiritual Immersion'
          }
        ]
      }
    ]
  },
  {
    id: 'ladakh-sikkim-curated',
    name: 'Curated Himalayan Journey',
    shortName: 'Curated Tours',
    description: 'Bespoke experiences across Ladakh, Sikkim, Arunachal & Meghalaya',
    region: 'Multi-Region',
    basePrice: 2500,
    baseDuration: 10,
    baseDifficulty: 'easy-moderate',
    heroImage: 'https://images.unsplash.com/photo-1619837374214-f5b9eb80876d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxMYWRha2h8ZW58MHx8fHwxNzYwNjkxOTg2fDA&ixlib=rb-4.1.0&q=85',
    mapRoute: 'M50,200 L150,200 L250,200 L350,200 L450,200',
    baseItinerary: [
      { day: 1, title: 'Arrival in Leh', location: { x: 50, y: 200 } },
      { day: 2, title: 'Leh Acclimatization', location: { x: 50, y: 200 } },
      { day: 3, title: 'Leh Local Monasteries', location: { x: 80, y: 200 } },
      { day: 4, title: 'Nubra Valley via Khardung La', location: { x: 150, y: 180 } },
      { day: 5, title: 'Nubra Valley Exploration', location: { x: 150, y: 180 } },
      { day: 6, title: 'Pangong Tso Lake', location: { x: 250, y: 200 } },
      { day: 7, title: 'Pangong to Leh', location: { x: 50, y: 200 } },
      { day: 8, title: 'Tso Moriri Lake', location: { x: 200, y: 240 } },
      { day: 9, title: 'Return to Leh', location: { x: 50, y: 200 } },
      { day: 10, title: 'Departure', location: { x: 50, y: 200 } }
    ],
    decisionPoints: [
      {
        id: 'curated-region',
        title: 'Choose Your Primary Region',
        description: 'Which Himalayan destination calls to you?',
        timing: 'start',
        options: [
          {
            id: 'ladakh-focus',
            title: 'Ladakh - The Land of High Passes',
            description: 'High-altitude deserts, ancient monasteries, and stunning lakes',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Adventure',
            selected: true
          },
          {
            id: 'sikkim-focus',
            title: 'Sikkim - Mystical Mountains',
            description: 'Kanchenjunga views, Buddhist culture, and pristine nature',
            impact: { days: 0, cost: 200, difficulty: 0 },
            badge: 'Culture & Nature'
          },
          {
            id: 'arunachal-focus',
            title: 'Arunachal Pradesh - The Rising Sun',
            description: 'Remote monasteries, tribal cultures, and untouched landscapes',
            impact: { days: 0, cost: 500, difficulty: 1 },
            badge: 'Offbeat'
          },
          {
            id: 'meghalaya-focus',
            title: 'Meghalaya - Abode of Clouds',
            description: 'Living root bridges, waterfalls, and lush green valleys',
            impact: { days: 0, cost: 150, difficulty: 0 },
            badge: 'Natural Wonders'
          }
        ]
      },
      {
        id: 'curated-style',
        title: 'Travel Style',
        description: 'How would you like to experience this region?',
        timing: 'day2',
        options: [
          {
            id: 'balanced-tour',
            title: 'Balanced Exploration',
            description: 'Mix of cultural sites, nature, and adventure',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Balanced',
            selected: true
          },
          {
            id: 'luxury-tour',
            title: 'Luxury Boutique Journey',
            description: '5-star hotels, private guides, and exclusive experiences',
            impact: { days: 0, cost: 1500, difficulty: -1 },
            badge: 'Premium'
          },
          {
            id: 'adventure-tour',
            title: 'Adventure Focused',
            description: 'More trekking, camping, and off-road exploration',
            impact: { days: 2, cost: 400, difficulty: 2 },
            badge: 'Adventurous'
          }
        ]
      },
      {
        id: 'curated-extension',
        title: 'Regional Extension',
        description: 'Add another destination to your journey',
        timing: 'day8',
        options: [
          {
            id: 'no-extension',
            title: 'Focus on Primary Region',
            description: 'Deep dive into your chosen destination',
            impact: { days: 0, cost: 0, difficulty: 0 },
            badge: 'Focused',
            selected: true
          },
          {
            id: 'add-sikkim',
            title: 'Add Sikkim Extension',
            description: 'Combine regions for a multi-state Himalayan odyssey',
            impact: { days: 5, cost: 1200, difficulty: 1 },
            badge: 'Extended Journey',
            addedItinerary: [
              { day: 'X+1', title: 'Travel to Gangtok' },
              { day: 'X+2', title: 'Tsomgo Lake & Baba Mandir' },
              { day: 'X+3', title: 'Gurudongmar Lake' },
              { day: 'X+4', title: 'Pelling & Pemayangtse' },
              { day: 'X+5', title: 'Departure from Bagdogra' }
            ]
          }
        ]
      }
    ]
  }
];

// Profile questions shown contextually during the journey building
export const profileQuestions = [
  {
    id: 'altitude-experience',
    question: 'To prepare for the altitude, what\'s the highest you\'ve been?',
    timing: 'afterFirstChoice',
    type: 'single',
    options: [
      { value: 'low', label: 'Below 3,000m', score: 1 },
      { value: 'medium', label: '3,000m - 4,500m', score: 2 },
      { value: 'high', label: 'Above 4,500m (I\'m a seasoned high-altitude trekker!)', score: 3 }
    ]
  },
  {
    id: 'adventure-interests',
    question: 'What fuels your adventurer\'s heart?',
    timing: 'afterSecondChoice',
    type: 'multiple',
    maxSelections: 2,
    options: [
      { value: 'trekking', label: 'Trekking & Summits' },
      { value: 'cycling', label: 'Cycling on the Edge' },
      { value: 'cultural', label: 'Cultural Deep-Dives' },
      { value: 'offbeat', label: 'Offbeat & Untouched Journeys' }
    ]
  },
  {
    id: 'duration-preference',
    question: 'How long can you escape for?',
    timing: 'afterThirdChoice',
    type: 'single',
    options: [
      { value: 'short', label: 'A Wild Weekend (3-5 days)', score: 1 },
      { value: 'medium', label: 'A Solid Quest (1-2 weeks)', score: 2 },
      { value: 'long', label: 'An Epic Saga (3+ weeks)', score: 3 }
    ]
  },
  {
    id: 'accommodation-style',
    question: 'Where do you rest your head after a day of exploration?',
    timing: 'afterFourthChoice',
    type: 'single',
    options: [
      { value: 'boutique', label: 'Boutique Hotels (Comfort is key)' },
      { value: 'homestay', label: 'Authentic Homestays (Connect with culture)' },
      { value: 'camping', label: 'Under the Stars (Camping)' }
    ]
  },
  {
    id: 'travel-style',
    question: 'Describe your travel style',
    timing: 'beforeFinal',
    type: 'single',
    options: [
      { value: 'minimalist', label: 'Minimalist (Focus on the experience)' },
      { value: 'balanced', label: 'Balanced (Comfort & Adventure)' },
      { value: 'luxury', label: 'Luxury (The 5-Star Adventure)' }
    ]
  },
  {
    id: 'future-regions',
    question: 'Any regions calling your name next?',
    timing: 'final',
    type: 'text',
    placeholder: 'Share your dream destinations...'
  }
];

// Generate adventurer persona based on profile answers
export const generatePersona = (profileAnswers) => {
  const { altitudeExperience, adventureInterests, travelStyle, accommodationStyle } = profileAnswers;
  
  let persona = '';
  let description = '';
  
  // Determine persona type
  if (altitudeExperience === 'high' && travelStyle === 'minimalist') {
    persona = 'The High-Altitude Purist';
    description = 'You thrive in thin air and seek authentic experiences above the clouds';
  } else if (travelStyle === 'luxury' && accommodationStyle === 'boutique') {
    persona = 'The Luxury Explorer';
    description = 'You demand excellence in both adventure and comfort';
  } else if (adventureInterests?.includes('cultural')) {
    persona = 'The Cultural Voyager';
    description = 'You seek deep connections with local traditions and people';
  } else if (adventureInterests?.includes('offbeat')) {
    persona = 'The Trailblazer';
    description = 'You venture where few have gone, seeking untouched paths';
  } else if (accommodationStyle === 'camping') {
    persona = 'The Mountain Nomad';
    description = 'You find home under starlit skies and mountain peaks';
  } else {
    persona = 'The Balanced Adventurer';
    description = 'You expertly blend comfort with authentic experiences';
  }
  
  return { persona, description };
};
